var _circle, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCheckDeliveryDate(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#BCF9E0"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7480_7369)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M41.12 63.477L71.7516 31.5231C72.7864 30.4437 74.4736 30.4338 75.5201 31.5011C75.5273 31.5084 75.5344 31.5157 75.5414 31.5231C76.5914 32.6184 76.5914 34.3812 75.5414 35.4764L43.1178 69.2997C42.9274 69.4983 42.7149 69.6608 42.4884 69.7869C41.4664 70.4365 40.1098 70.309 39.2183 69.3997C39.2111 69.3925 39.204 69.3851 39.197 69.3778L25.3011 54.8821C24.2512 53.7868 24.2512 52.024 25.3011 50.9287C26.3359 49.8493 28.0231 49.8394 29.0696 50.9067C29.0768 50.914 29.0839 50.9213 29.0909 50.9287L41.12 63.477Z",
    fill: "#0BB873"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7480_7369"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 53,
    height: 41,
    fill: "white",
    transform: "translate(24 30)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCheckDeliveryDate);
export default __webpack_public_path__ + "static/media/iconCheckDeliveryDate.8b8aafb022cd4589486fd7bbcc29c550.svg";
export { ForwardRef as ReactComponent };